import { render, staticRenderFns } from "./LogsServInfo.vue?vue&type=template&id=ae01b87c&scoped=true&"
import script from "./LogsServInfo.vue?vue&type=script&lang=js&"
export * from "./LogsServInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae01b87c",
  null
  
)

export default component.exports